<template>
	<el-dialog :modelValue="open" @update:modelValue="$emit('update:open', $event)" :title="'Angaben fehlen'" align-center>
		<el-alert
			:title="'Es wurden noch nicht alle Pflichtfelder ausgefüllt. Wenn Sie ohne Speichern verlassen, gehen die bisherigen Eingaben verloren.'"
			type="error"
			:closable="false"
			effect="dark"
			show-icon
		/>

		<template #footer>
			<div class="button-panel">
				<TheButton
					type="primary"
					@buttonclick="
						$emit('cancel');
						$emit('update:open', false);
					"
				>
					Ohne Speichern verlassen
				</TheButton>
				<TheButton type="primary" @buttonclick="$emit('update:open', false)">Bearbeitung fortsetzen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheButton from '../TheButton.vue';

export default defineComponent({
	name: 'DialogeLeavePageCaseErr',
	data() {
		return {};
	},
	components: {
		TheButton,
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['cancel', 'update:open'],
	computed: {},
	methods: {},
	mounted() {},
});
</script>

<style lang="scss"></style>
